import React from 'react'
import { Form } from 'hhsoig-design-system-core'
import { ErrorBoundary } from '../../components/errorBoundary'
import css from './ComplaintForm.module.css'

export const ComplaintForm = ({ schema, headerContent }) => (
  <ErrorBoundary>
    <main className={`ds-l-container ${css.gridContainer}`}>
      <div className="ds-l-row">
        <div className="ds-l-md-col--8 ds-l-sm-col--12">
          {headerContent}
          <Form schema={schema} />
        </div>
      </div>
    </main>
  </ErrorBoundary>
)
